import React from 'react'

export const AppStateContext = React.createContext()

export default AppStateContext.Provider
